<template>
  <b
    v-if="projectAum !== undefined"
    class="aum"
  >
    <v-icon class="btc-icon-15 text-primary">mdi-currency-btc</v-icon>
    {{ projectAum.aum }} 
  </b>
</template>

<script>

const PROJECT_AUM_QUERY = require('@/graphql/queries/ProjectAum.gql');

export default {
  props: {
    projectId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    
  },
  apollo: {
    projectAum: {
      query: PROJECT_AUM_QUERY,
      variables() {
        return {
          id: this.projectId
        }
      },
    }
  },
};
</script>

<style lang="scss">

</style>
